import { isNil } from 'lodash';
import moment from 'moment';
import NumericFilter from './NumericFilter';

class WorkflowStatusAgeFilter extends NumericFilter {
  // @ts-expect-error overridden params
  matches(record: { durationInTeamWorkflowStatus: number }) {
    // Convert the duration to days for the filter match
    return super.matches(
      isNil(record.durationInTeamWorkflowStatus)
        ? null
        : Math.round(
            moment
              .duration(record.durationInTeamWorkflowStatus, 'seconds')
              .asDays()
          )
    );
  }
}

export default WorkflowStatusAgeFilter;
